/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */

import React, { useEffect } from 'react';
import { Drawer, Form, Select, Button } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { style } from '../../../Styles';
import { bookingStatuses } from '../../../Utils/Constants/utils';

const FilteringDrawer = ({
	closeFilteringDrawer,
	isFilteringDrawerOpened,
	resetFilter,
	role,
	form,
	onSave,
	corporateAdminId,
	allowedCorporateIds,
}) => {
	const location = useLocation();

	const { Riders } = useSelector((state) => state.riders);
	const { Drivers } = useSelector((state) => state.drivers);
	const fleetOperatorList = useSelector(
		(state) => state.fleetOperator.fleetOperator.fleetOperatorList,
	);
	const { corporates } = useSelector((state) => state.corporates);

	const getSpanStyle = (status) => {
		switch (status) {
			case 'Completed':
				return style.statusCompleted;
			case 'Cancelled':
				return style.statusCancelled;
			case 'Pending':
				return style.statusPending;
			case 'In Progress':
				return style.statusInProgress;
			case 'Accepted':
				return style.statusAccepted;
			case 'Requested':
				return style.statusRequested;
			case 'Timed Out':
				return style.statusTimedOut;
			default:
				break;
		}
	};
	useEffect(() => {
		if (location?.state?.status) {
			const bookingStatus = bookingStatuses.find(
				(status) => status.enum === location?.state?.status,
			);
			form.setFieldsValue({ statusId: bookingStatus.id });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location?.state?.status]);

	useEffect(() => {
		if (corporateAdminId) {
			form.setFieldsValue({ corporateId: corporateAdminId });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [corporateAdminId]);

	const handleResetForm = () => {
		if (location && location.state) {
			location.state.status = null;
		}
		form.setFieldsValue({
			statusId: null,
			driverId: null,
			riderId: null,
			// preserve the locked corporate for corporate admins
			corporateId: corporateAdminId ?? null,
		});
		resetFilter();
	};



	const onDrawerClose = () => {
		// close drawer
		closeFilteringDrawer();
	};
	return (
		<Drawer
			form={form}
			title='Filter bookings'
			placement='right'
			closable={false}
			onClose={onDrawerClose}
			width={400}
			open={isFilteringDrawerOpened}>
			<Form
				form={form}
				name='Booking filter'
				layout='vertical'
				initialValues={{}}
				onFinish={(values) => onSave(values)}
				onFinishFailed={() => { }}
				autoComplete='off'
				onValuesChange={() => { }}>
				<Form.Item label='Status' name='statusId'>
					<Select
						showArrow
						showSearch
						optionFilterProp='filterBy'
						allowClear
						onClear={() => {
							form.setFieldsValue({ statusId: null });
							location.state.status = null;
						}}
						optionLabelProp='label'>
						{bookingStatuses.map((status) => (
							<Select.Option
								key={status.name}
								filterBy={status.name}
								value={status.id}
								label={status.name}>
								<span style={style.dataContainer}>
									<div style={getSpanStyle(status.name)}>{status.name}</div>
								</span>
							</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label='Driver' name='driverId'>
					<Select
						size='medium'
						showArrow
						showSearch
						optionFilterProp='filterBy'
						allowClear
						optionLabelProp='label'>
						{Drivers.allDrivers?.map((p) => (
							<Select.Option
								key={p.id}
								filterBy={`${p.name}`}
								label={`${p.name} ${p.surname}`}
								// disabled={!p.active}
								value={p.id}>
								<div>{` ${p.name}  ${p.surname}`}</div>
								<span style={{ color: 'gray' }}>{p.email}</span>
							</Select.Option>
						))}
					</Select>
				</Form.Item>
				{role?.includes('SUPER_ADMIN') && (
					<Form.Item label='Rider' name='riderId'>
						<Select
							size='medium'
							showArrow
							showSearch
							optionFilterProp='filterBy'
							allowClear
							optionLabelProp='label'>
							{Riders.allRiders?.map((p) => (
								<Select.Option
									key={p.id}
									filterBy={`${p.name}`}
									label={
										role?.includes('SUPER_ADMIN')
											? `${p?.name} ${p?.surname} `
											: `${p?.name}`
									}
									// disabled={!p.active}
									value={p.id}>
									<div>
										{role?.includes('SUPER_ADMIN')
											? `${p?.name} ${p?.surname} `
											: `${p?.name}`}
									</div>
									{role?.includes('SUPER_ADMIN') && (
										<span style={{ color: 'gray' }}>{p.email}</span>
									)}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				)}

				{role?.includes('SUPER_ADMIN') || role?.includes('CORPORATE_ADMIN') ? (
					<Form.Item label='Corporate' name='corporateId'>
						<Select
							size='medium'
							showArrow
							showSearch
							optionFilterProp='filterBy'
							allowClear={!corporateAdminId}
							disabled={!!corporateAdminId}
							optionLabelProp='label'>
						{corporates?.corporatesList
							?.filter((p) =>
								allowedCorporateIds?.length > 0
									? allowedCorporateIds.includes(p.id)
									: true,
							)
							?.map((p) => (
								<Select.Option
									key={p.id}
									filterBy={`${p.name}`}
									label={`${p.name}`}
									value={p.id}>
									<div>{`${p.name}`}</div>
									<span style={{ color: 'gray' }}>{p.email}</span>
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				) : null}
				{role?.includes('SUPER_ADMIN') ? (
					<Form.Item label='Fleet Operator' name='fleetOperatorId'>
						<Select
							size='medium'
							showArrow
							showSearch
							optionFilterProp='filterBy'
							allowClear
							optionLabelProp='label'>
							{fleetOperatorList?.map((p) => (
								<Select.Option
									key={p.id}
									filterBy={`${p.name}`}
									label={`${p.name}`}
									value={p.id}>
									<div>{`${p.name}`}</div>
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				) : null}

				<Form.Item style={{ float: 'right' }}>
					<Button
						type='default'
						style={{ marginBottom: 32, marginRight: 8 }}
						onClick={() => closeFilteringDrawer()}>
						Cancel
					</Button>
					<Button type='primary' style={{ marginBottom: 32 }} htmlType='submit'>
						Filter
					</Button>
				</Form.Item>
				<Form.Item style={{ float: 'left' }}>
					<Button
						type='default'
						styles={{ backgroundColor: 'red' }}
						style={{ marginBottom: 32, marginRight: 8 }}
						onClick={() => handleResetForm()}>
						Reset filter
					</Button>
				</Form.Item>
			</Form>
		</Drawer>
	);
};

export default FilteringDrawer;
